





















































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import ChartOneVue from "../components/BusinessAnalysis/ChartOne.vue";
import ChartTwoVue from "../components/BusinessAnalysis/ChartTwo.vue";
import ChartThreeVue from "../components/BusinessAnalysis/ChartThree.vue";
import ChartFourVue from "../components/BusinessAnalysis/ChartFour.vue";
import SideNavVue from "../components/SideNav.vue";
import TabNavVue from "../components/TabNav.vue";
@Component({
    ...mapGetters(["account"]),
    components: {
        "chart-one": ChartOneVue,
        "chart-two": ChartTwoVue,
        "chart-three": ChartThreeVue,
        "chart-four": ChartFourVue,
        "side-nav": SideNavVue,
        "tab-nav": TabNavVue,
    }
})
export default class BusinessAnalysis extends Vue {
    dateTime: string = ""
    currentView: string = "chart-one";//切换页面
    typeName: string = ""
    //客户数查看新增减少图表 
    tabs: DataTable.DropItem[] = [
        {
            id: 0,
            text: "全部"
        },
        {
            id: 1,
            text: "新增"
        },
        {
            id: 2,
            text: "减少"
        }
    ];
    activeTab: DataTable.DropItem = { id: 0, text: "全部" }
    created() {
        this.changeDateTime();
    }
    // 初始化dateTime
    changeDateTime() {
        if (this.currentView === "chart-two") {
            this.dateTime = this.$utils.simpleDateFormat(
                new Date(),
                "m",
                true
            );
        } else if (this.currentView === "chart-three") {
            this.dateTime = this.$utils.simpleDateFormat(
                new Date(),
                "m",
                true
            );
        } else {
            this.dateTime = new Date().getFullYear().toString();
        }
    }
    // 选择时间
    changeDate(val: Date) {
        if (Object.prototype.toString.call(val) === "[object String]") return;
        if (this.currentView === "chart-two") {
            this.dateTime = this.$utils.simpleDateFormat(
                val,
                "m",
                true
            );
        } else if (this.currentView === "chart-three") {
            this.dateTime = this.$utils.simpleDateFormat(
                val,
                "m",
                true
            );
        } else {
            this.dateTime = val.getFullYear().toString();
        }
    }
    // 获取时间范围
    get disabledDate() {
        return {
            disabledDate: (time: Date) => {
                return time.getFullYear() > new Date().getFullYear();
            }
        }
    };
    // 切换侧边栏
    changeTab(val: string) {
        if (val == "收入趋势图") {
            this.currentView = "chart-one";
            this.changeDateTime();
        } else if (val == "全国客户数") {
            if (this.currentView === "chart-two") {
                this.changeNav(this.tabs[0]);
                this.activeTab = this.tabs[0];
            } else {
                this.currentView = "chart-two";
                this.changeDateTime();
                this.activeTab = this.tabs[0];
            }
        } else if (val == "全国员工数") {
            if (this.currentView === "chart-three") {
                this.changeNav(this.tabs[0]);
                this.activeTab = this.tabs[0];
            } else {
                this.currentView = "chart-three";
                this.changeDateTime();
                this.activeTab = this.tabs[0];
            }
        } else {
            this.currentView = "chart-four";
            this.changeDateTime();
        }
    }
    navText: string = "全部";
    changeNav(nav: DataTable.DropItem) {
        let chart = <any>this.$refs.chart;
        if (nav.text === "新增") {
            this.navText = "新增";
            chart.fetchData(1);
        } else if (nav.text === "减少") {
            this.navText = "减少";
            chart.fetchData(-1);
        } else {
            this.navText = "全部";
            chart.fetchData(0);
        }
    }
}
